// extracted by mini-css-extract-plugin
export var acitonButtons = "_c2-0";
export var additionalIcon = "_c2-f";
export var block = "_c2-1";
export var blockContent = "_c2-7";
export var blockDescription = "_c2-8";
export var blockIcon = "_c2-9";
export var blockTitle = "_c2-6";
export var border = "_c2-a";
export var center = "_c2-l";
export var edge = "_c2-b";
export var edgeLabel = "_c2-c";
export var edgePath = "_c2-d";
export var error = "_c2-e";
export var flowchart = "_c2-g";
export var flowchartContent = "_c2-h";
export var highlighted = "_c2-3";
export var hover = "_c2-4";
export var icon = "_c2-i";
export var left = "_c2-m";
export var navButton = "_c2-j";
export var navButtons = "_c2-k";
export var right = "_c2-n";
export var selected = "_c2-2";
export var small = "_c2-5";